import React, {createContext, useReducer} from 'react'

export const SET_SYSTEM_LIST = 'SET_SYSTEM_LIST'
export const SELECT_SYSTEM = 'SELECT_SYSTEM'
export const SET_SHOW_SYSTEM_POPUP = 'SET_SHOW_SYSTEM_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SYSTEM_LIST:
      return { ...data, system_list: payload.data }
    case SELECT_SYSTEM:
      return {
        ...data,
        selected_system: payload.data.selected_system,
        show_system_popup: payload.data.show_system_popup,
      }
    case SET_SHOW_SYSTEM_POPUP:
      return {
        ...data,
        show_system_popup: payload.data,
        selected_system: payload.data ? data.selected_system : {},
      }
    default:
      return data
  }
}

const initialState = {
  system_list: [],
  selected_system: {},
  show_system_popup: false,
}

const SystemStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <SystemContext.Provider value={[state, dispatch]}>
      {children}
    </SystemContext.Provider>
  )
}

export const SystemContext = createContext(initialState)
export default SystemStore
